import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '@env';

export interface AppVersionInfo {
  version: string;  // from package.json (e.g., 1.6.3)
  release: string;  // CI-stamped (e.g., 1.6.3-dev.124+4db35cf)
  env: string;      // dev/staging/prod
  builtAt: string;  // ISO timestamp
  commit: string;   // full SHA if available
}

@Injectable({ providedIn: 'root' })
export class VersionService {
  private cached?: AppVersionInfo;

  constructor(private http: HttpClient) {}

  async get(): Promise<AppVersionInfo> {
    if (this.cached) return this.cached;

    try {
      // prefer CI-stamped file
      const info = await firstValueFrom(
        this.http.get<AppVersionInfo>('assets/version.json')
      );
      this.cached = info;
      return info;
    } catch {
      // fallback if running locally without version.json
      const fallback: AppVersionInfo = {
        version: environment.appVersion ?? 'dev',
        release: environment.sentryRelease ?? 'dev-local',
        env: environment.appStage ?? 'local',
        builtAt: new Date().toISOString(),
        commit: 'local',
      };
      this.cached = fallback;
      return fallback;
    }
  }
}
